import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import ToastView, { ToastShow } from "../Toast/Toast";
import { ADD_UPDATE_NEW_ON_SPOT_FAQ} from "../../Apis/new_on_spot_api";

function AddUpdateNewOnSpotFaq({ open, handleOnClose, on_spot_id, row }) {
  const [isLoading, setIsLoading] = useState(false);
  const [questions, setQuestions] = React.useState(row?.questions ?? "");
  const [answer, setAnswer] = React.useState(row?.answer ?? "");

  const handleOnSubmit = async () => {
    if (!questions) {
      ToastShow("Please enter questions");
    } else if (!answer) {
      ToastShow("Please enter answer ");
    } else {
      setIsLoading(true);
      const d = await ADD_UPDATE_NEW_ON_SPOT_FAQ({
        id: row?.id ?? 0,
        on_spot_id: on_spot_id,
        questions: questions,
        answer: answer,
      });
      setIsLoading(false);
      if (d && d.s) {
        ToastShow("Successfully added");
        handleOnClose(1);
      } else {
        ToastShow("Something went wrong. Please try again.");
      }
    }
  };

  return (
    <>
      <Dialog open={open} onClose={() => handleOnClose(0)}>
        <DialogTitle>{!row?.id ? "Add FAQ" : "Update FAQ"}</DialogTitle>
        <DialogContent
          sx={{
            width: "400px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TextField
            sx={{
              width: "85%",
              mt: 2,
            }}
            size="small"
            fullWidth
            label="Question"
           
            value={questions}
            onChange={(e) => setQuestions(e.target.value)}
          />
          <TextField
            sx={{
              width: "85%",
              mt: 2,
            }}
            size="small"
            fullWidth
            multiline
            rows={4}
            label="Answer"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
          />
        </DialogContent>

        <DialogActions>
          {isLoading ? (
            <CircularProgress />
          ) : (
            <Button onClick={handleOnSubmit} variant="text">
              Submit
            </Button>
          )}
          <Button onClick={() => handleOnClose(0)} variant="text">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <ToastView />
    </>
  );
}

export default AddUpdateNewOnSpotFaq;
